module.exports = __webpack_public_path__ + "static/media/CrispLinen.ef09369e.jpg";